var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye24 = function SvgEye24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3.092,
    stroke: "currentColor",
    strokeWidth: "var(--icon-stroke-width, 1.2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.2)",
    d: "M12 6.991c2.42 0 4.346 1.014 5.762 2.174A12.653 12.653 0 0 1 20.296 12a12.655 12.655 0 0 1-2.534 2.835c-1.416 1.16-3.342 2.174-5.762 2.174-2.42 0-4.346-1.014-5.762-2.174A12.663 12.663 0 0 1 3.703 12a12.663 12.663 0 0 1 2.535-2.835C7.654 8.005 9.58 6.99 12 6.99Z"
  })));
};
export default SvgEye24;